import { useState, useCallback } from "react";

const useValidacionesModals = () => {
  const [showHojaQuirurgicaModal, setShowHojaQuirurgicaModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [documentoModal, setDocumentoModal] = useState(null);
  const [showCoberturasRequeridasAlert, setShowCoberturasRequeridasAlert] =
    useState(false);
  const [showResultadoEnvioModal, setShowResultadoEnvioModal] = useState(false);
  const [resultadoEnvio, setResultadoEnvio] = useState(null);
  const [showConfirmarEliminarCobertura, setShowConfirmarEliminarCobertura] =
    useState(false);
  const [coberturaAEliminar, setCoberturaAEliminar] = useState(null);
  const [showConfirmarEliminarAnexo, setShowConfirmarEliminarAnexo] =
    useState(false);
  const [anexoAEliminar, setAnexoAEliminar] = useState(null);
  const [showCoberturasDuplicadasModal, setShowCoberturasDuplicadasModal] =
    useState(false);
  const [showUploadResultsModal, setShowUploadResultsModal] = useState(false);
  const [showModalEncuestaSatisfaccion, setShowModalEncuestaSatisfaccion] =
    useState(false);
  const [showCirugiasLiberadasModal, setShowCirugiasLiberadasModal] =
    useState(false);
  const [cirugiasLiberadasData, setCirugiasLiberadasData] = useState(null);
  const [showConfirmarEnvioCoberturas, setShowConfirmarEnvioCoberturas] =
    useState(false);

  const abrirModalDocumento = useCallback((documento) => {
    setDocumentoModal(documento);
    setModalVisible(true);
  }, []);

  const cerrarModalDocumento = useCallback(() => {
    setModalVisible(false);
    setDocumentoModal(null);
  }, []);

  const handleOpenHojaQuirurgicaModal = useCallback(() => {
    setShowHojaQuirurgicaModal(true);
  }, []);

  const handleCloseHojaQuirurgicaModal = useCallback(() => {
    setShowHojaQuirurgicaModal(false);
  }, []);

  const handleCloseCoberturasRequeridasAlert = useCallback(() => {
    setShowCoberturasRequeridasAlert(false);
  }, []);

  const handleVolverIngresos = useCallback(() => {
    setShowResultadoEnvioModal(false);
    setResultadoEnvio(null);
  }, []);

  const handleEliminarCobertura = useCallback((key) => {
    setCoberturaAEliminar(key);
    setShowConfirmarEliminarCobertura(true);
  }, []);

  const confirmarEliminarCobertura = useCallback(
    (onConfirm) => {
      if (coberturaAEliminar !== null && onConfirm) {
        onConfirm(coberturaAEliminar);
      }
      setShowConfirmarEliminarCobertura(false);
      setCoberturaAEliminar(null);
    },
    [coberturaAEliminar]
  );

  const cancelarEliminarCobertura = useCallback(() => {
    setShowConfirmarEliminarCobertura(false);
    setCoberturaAEliminar(null);
  }, []);

  const handleEliminarAnexo = useCallback((archivoId) => {
    setAnexoAEliminar(archivoId);
    setShowConfirmarEliminarAnexo(true);
  }, []);

  const confirmarEliminarAnexo = useCallback(
    (onConfirm) => {
      if (anexoAEliminar !== null && onConfirm) {
        onConfirm(anexoAEliminar);
      }
      setShowConfirmarEliminarAnexo(false);
      setAnexoAEliminar(null);
    },
    [anexoAEliminar]
  );

  const cancelarEliminarAnexo = useCallback(() => {
    setShowConfirmarEliminarAnexo(false);
    setAnexoAEliminar(null);
  }, []);

  const handleCerrarCoberturasDuplicadasModal = useCallback(
    (onClose) => {
      setShowCoberturasDuplicadasModal(false);
      if (onClose) {
        onClose();
      }
    },
    []
  );

  const handleCerrarCirugiasLiberadasModal = useCallback(() => {
    setShowCirugiasLiberadasModal(false);
    setCirugiasLiberadasData(null);
  }, []);

  const handleCerrarConfirmarEnvioCoberturas = useCallback(() => {
    setShowConfirmarEnvioCoberturas(false);
  }, []);

  return {
    showHojaQuirurgicaModal,
    modalVisible,
    documentoModal,
    showCoberturasRequeridasAlert,
    showResultadoEnvioModal,
    resultadoEnvio,
    showConfirmarEliminarCobertura,
    coberturaAEliminar,
    showConfirmarEliminarAnexo,
    anexoAEliminar,
    showCoberturasDuplicadasModal,
    showUploadResultsModal,
    showCirugiasLiberadasModal,
    cirugiasLiberadasData,
    abrirModalDocumento,
    cerrarModalDocumento,
    handleOpenHojaQuirurgicaModal,
    handleCloseHojaQuirurgicaModal,
    handleCloseCoberturasRequeridasAlert,
    handleVolverIngresos,
    handleEliminarCobertura,
    confirmarEliminarCobertura,
    cancelarEliminarCobertura,
    handleEliminarAnexo,
    confirmarEliminarAnexo,
    cancelarEliminarAnexo,
    handleCerrarCoberturasDuplicadasModal,
    handleCerrarCirugiasLiberadasModal,
    setShowCoberturasRequeridasAlert,
    setShowResultadoEnvioModal,
    setResultadoEnvio,
    setShowCoberturasDuplicadasModal,
    setShowUploadResultsModal,
    showModalEncuestaSatisfaccion,
    setShowModalEncuestaSatisfaccion,
    setShowCirugiasLiberadasModal,
    setCirugiasLiberadasData,
    showConfirmarEnvioCoberturas,
    setShowConfirmarEnvioCoberturas,
    handleCerrarConfirmarEnvioCoberturas,
  };
};

export default useValidacionesModals;

